import { Pipe, PipeTransform } from '@angular/core';
import {
  ApplicantAppEntityApplicantWrite,
  ApplicantAppEntityApplicationRead,
  ContractorAppEntityApplicationRead,
  ContractorAppEntityContractorWrite
} from '../openapi';
import { getEntityTypeNameById } from './entity-type.pipe';

@Pipe({
  name: 'entityLabel',
  standalone: true
})
export class EntityLabelPipe implements PipeTransform {

  public transform(value?: ApplicantAppEntityApplicantWrite | ApplicantAppEntityApplicationRead | ContractorAppEntityApplicationRead | ContractorAppEntityContractorWrite): string {
    if (!value) {
      return '';
    }
    if (typeof value.entityType === 'string') {
      return `${value?.name || value?.firstName + ' ' + value?.lastName}, ${getEntityTypeNameById(value.entityType)}`;
    } else {
      return `${value?.name || value?.firstName + ' ' + value?.lastName}, ${value.entityType?.name}`;
    }

  }

}
